import { getPercent } from "@helpers";
import { SecuritiesChartDataWithDate } from "@components/Chart";

export const calculatePercentsForPerformance = (
  data: SecuritiesChartDataWithDate[],
  isComparison = false
) => {
  let reference = data[0];
  let comparedValue = 1;

  return data.map((current) => {
    const step = {
      ...current,
      totalValue: getPercent(current.totalValue),
      holdingsValue: getPercent(current.holdingsValue),
      fondsValue: getPercent(current.fondsValue),
      etfsValue: getPercent(current.etfsValue),
      derivativeValue: getPercent(current.derivativeValue),
      // A factor of 0 is a total loss (-100 %); only a missing value stays.
      bondsValue:
        current.bondsValue !== undefined
          ? getPercent(current.bondsValue)
          : current.bondsValue,
      cryptoValue:
        current.cryptoValue !== undefined
          ? getPercent(current.cryptoValue)
          : current.cryptoValue,
      areaValue: [
        getPercent(current.areaValue[0]),
        getPercent(current.areaValue[1]),
      ] as [number, number],
    };

    if (isComparison) {
      const currentCompared = current.comparedValue ?? 0;
      const referenceCompared = reference.comparedValue ?? 0;
      if (current.comparedValue && reference.comparedValue) {
        comparedValue *= currentCompared / referenceCompared;
      }
      step.comparedValue = getPercent(comparedValue);
    }

    reference = current;

    return step;
  });
};
